export default {
  'business-growth': 'Bauen Sie Ihr Business aus',
}
